/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_All_PermissionsInputs */

const en_admin_permissions_all_permissions = /** @type {(inputs: Admin_Permissions_All_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Permissions`)
};

/**
* | output |
* | --- |
* | "All Permissions" |
*
* @param {Admin_Permissions_All_PermissionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_all_permissions = /** @type {((inputs?: Admin_Permissions_All_PermissionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_All_PermissionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_all_permissions(inputs)
});
export { admin_permissions_all_permissions as "admin.permissions.all_permissions" }